import React, { Fragment } from 'react'

function Noticias(props) {
   

    return (
        <Fragment>
            <div className='d-flex justify-content-between flex-wrap'>

                <div className='text-justify col-4 bg-light p-2 me-1 mt-1 w__full'>
                    <h4>Noticia 1</h4>
                    <p className='fs-6 text'></p>
                    <p style={{ textAlign: 'justify' }}>
                        Lorem ipsum dolor sit amet consectetur adipisicing
                         elit. Ratione nam minus eos asperiores iste 
                         recusandae laboriosam repellat beatae 
                         distinctio libero praesentium qui 
                         repellendus omnis, quam similique ad optio iusto alias.
                        <span className='text-info'>ver noticia</span>
                    </p>
                </div>

                <div className='text-justify col-4 bg-light p-2 me-1 mt-1 w__full'>
                    <h4>Noticia 1</h4>
                    <p className='fs-6 text'></p>
                    <p style={{ textAlign: 'justify' }}>
                        Lorem ipsum dolor sit amet consectetur adipisicing
                         elit. Ratione nam minus eos asperiores iste 
                         recusandae laboriosam repellat beatae 
                         distinctio libero praesentium qui 
                         repellendus omnis, quam similique ad optio iusto alias.
                        <span className='text-info'>ver noticia</span>
                    </p>
                </div>

                <div className='text-justify col-4 bg-light p-2 me-1 mt-1 w__full'>
                    <h4>Noticia 1</h4>
                    <p className='fs-6 text'></p>
                    <p style={{ textAlign: 'justify' }}>
                        Lorem ipsum dolor sit amet consectetur adipisicing
                         elit. Ratione nam minus eos asperiores iste 
                         recusandae laboriosam repellat beatae 
                         distinctio libero praesentium qui 
                         repellendus omnis, quam similique ad optio iusto alias.
                        <span className='text-info'>ver noticia</span>
                    </p>
                </div>

                <div className='text-justify col-4 bg-light p-2 me-1 mt-1 w__full'>
                    <h4>Noticia 1</h4>
                    <p className='fs-6 text'></p>
                    <p style={{ textAlign: 'justify' }}>
                        Lorem ipsum dolor sit amet consectetur adipisicing
                         elit. Ratione nam minus eos asperiores iste 
                         recusandae laboriosam repellat beatae 
                         distinctio libero praesentium qui 
                         repellendus omnis, quam similique ad optio iusto alias.
                        <span className='text-info'>ver noticia</span>
                    </p>
                </div>


            </div>
        </Fragment>
    )
}

export default Noticias